/* eslint-disable import/prefer-default-export */
import { PostErrors } from 'src/types/DiscussionPost';
import { ErrorType } from 'src/types/Errors';

export const DiscussionPostErrors = {
  [PostErrors.voteSubmission]: {
    header: 'request_threadDetailVoteSubmitFailureHeader',
    description: 'request_threadDetailVoteSubmitFailureDescription',
  },
  [PostErrors.fetchNextReplies]: {
    header: 'request_threadDetailsFetchFailureHeader',
    description: 'request_threadDetailsFetchFailureDescription',
  },
  [PostErrors.fetchPreviousReplies]: {
    header: 'request_threadDetailsFetchFailureHeader',
    description: 'request_threadDetailsFetchFailureDescription',
  },
  [PostErrors.copyPost]: {
    header: 'request_copyPostLinkFailureHeader',
    description: 'request_copyPostLinkFailureDescription',
  },
  [PostErrors.deletePost]: {
    header: 'request_deletePostFailureHeader',
    description: 'request_deletePostFailureDescription',
  },
  [PostErrors.deleteDraft]: {
    header: 'request_deleteDraftFailureHeader',
    description: 'request_deleteDraftFailureDescription',
  },
  [PostErrors.markSolution]: {
    header: 'request_markSolutionFailureHeader',
    description: 'request_markSolutionFailureDescription',
  },
  [PostErrors.lockedPost]: {
    header: 'threadDetail_lockedPostErrorHeader',
    description: 'threadDetail_lockedPostErrorDescription',
  },
  [PostErrors.flagPost]: {
    header: 'threadDetail_flagPostErrorHeader',
    description: 'threadDetail_flagPostErrorDescription',
  },
  [PostErrors.threadSubmission]: {
    header: 'request_createThreadSubmissionFailureHeader',
    description: 'request_createThreadSubmissionFailureDescription',
  },
  [PostErrors.postSubmission]: {
    header: 'request_threadDetailPostSubmissionFailureHeader',
    description: 'request_threadDetailPostSubmissionFailureDescription',
  },
  [PostErrors.notGroupMember]: {
    header: 'notGroupMember_header',
    description: 'notGroupMember_description',
  },
  [PostErrors.actionOnDeletedPost]: {
    header: 'badRequest_post_actionOnDeletedPostHeader',
    description: 'badRequest_post_actionOnDeletedPostDescription',
  },
  [PostErrors.actionForbidden]: {
    header: 'badRequest_post_actionForbiddenHeader',
    description: 'badRequest_post_actionForbiddenDescription',
  },
  [PostErrors.updateWindowCrossed]: {
    header: 'badRequest_post_updateWindowCrossedHeader',
    description: 'badRequest_post_updateWindowCrossedDescription',
  },
  [PostErrors.unauthorizedAction]: {
    header: 'badRequest_post_unauthorizedActionHeader',
    description: 'badRequest_post_unauthorizedActionDescription',
  },
  [PostErrors.opNotSameMarketplace]: {
    header: 'badRequest_post_opNotSameMarketplaceHeader',
    description: 'badRequest_post_opNotSameMarketplaceDescription',
  },
  [PostErrors.invalidContent]: {
    header: 'badRequest_invalid_content',
    description: 'badRequest_invalidContentDescription',
  },
  [PostErrors.opContainsReplies]: {
    header: 'badRequest_post_opContainsRepliesHeader',
    description: 'badRequest_post_opContainsRepliesDescription',
  },
  [PostErrors.cannotUpdateToDraft]: {
    header: 'badRequest_post_cannotUpdateToDraftHeader',
    description: 'badRequest_post_cannotUpdateToDraftDescription',
  },
  [PostErrors.postIsMarkedAsSolution]: {
    header: 'badRequest_post_postIsMarkedAsSolutionHeader',
    description: 'badRequest_post_postIsMarkedAsSolutionDescription',
  },
  [PostErrors.unauthorizedMarketplaceId]: {
    header: 'badRequest_post_unauthorizedMarketplaceIdHeader',
    description: 'badRequest_post_unauthorizedMarketplaceIdDescription',
  },
  [PostErrors.silenced]: {
    header: 'badRequest_post_silencedHeader',
    description: 'badRequest_post_silencedDescription',
  },
  [PostErrors.pinThread]: {
    header: 'request_pinThread_requestFailureHeader',
    description: 'request_pinThread_requestFailureDescription',
  },
  [PostErrors.hasNoAccessToPrivateDiscussion]: {
    header: 'threadDetail_private_group_no_access_title',
    description: 'threadDetail_private_group_no_access_description',
  },
};

export const DiscussionPostCreationErrors = {
  content: {
    [ErrorType.invalidContent]: 'badRequest_invalid_content',
    [ErrorType.duplicate]: 'badRequest_content_duplicate',
    [ErrorType.pii]: 'badRequest_content_pii',
    [ErrorType.inappropriateContent]: 'badRequest_content_inappropriateContent',
    [ErrorType.opNotSameMarketplace]: 'badRequest_action_opNotSameMarketplace',
    [ErrorType.hasNoAccess]: 'badRequest_content_hasNoAccess',
    [ErrorType.duplicatePresent]: 'badRequest_content_duplicatePresent',
    [ErrorType.maxLength]: 'badRequest_content_maxLength',
    [ErrorType.minLength]: 'badRequest_content_minLength',
    [ErrorType.containsProfanity]: 'badRequest_content_containsProfanity',
    [ErrorType.nonAmazonDomain]: 'badRequest_content_nonAmazonDomain',
    [ErrorType.invalidFormat]: 'badRequest_image_invalidFormat',
    [ErrorType.maxCount]: 'badRequest_image_maxCount',
  } as Record<Partial<ErrorType>, string>,
  title: {
    [ErrorType.duplicate]: 'title_error_duplicate',
    [ErrorType.opNotSameMarketplace]: 'badRequest_title_opNotSameMarketplace',
    [ErrorType.hasNoAccess]: 'badRequest_title_hasNoAccess',
    [ErrorType.duplicatePresent]: 'badRequest_title_duplicatePresent',
    [ErrorType.maxLength]: 'badRequest_title_maxLength',
    [ErrorType.minLength]: 'badRequest_title_minLength',
    [ErrorType.containsProfanity]: 'badRequest_title_containsProfanity',
    [ErrorType.nonAmazonDomain]: 'badRequest_title_nonAmazonDomain',
  } as Record<Partial<ErrorType>, string>,
};

export const EditUserProfileErrors = {
  username: {
    [ErrorType.usernameNotAvailable]: 'badRequest_error_username_unavailable',
  } as Record<Partial<ErrorType>, string>,
  aboutMe: {
    [ErrorType.containsPII]: 'badRequest_aboutMe_pii',
    [ErrorType.containsProfanity]: 'badRequest_aboutMe_inappropriateContent',
  } as Record<Partial<ErrorType>, string>,
  aboutMyBusiness: {
    [ErrorType.containsPII]: 'badRequest_aboutMyBusiness_pii',
    [ErrorType.containsProfanity]: 'badRequest_aboutMyBusiness_inappropriateContent',
  } as Record<Partial<ErrorType>, string>,
  avatarSrc: {
    [ErrorType.invalidImage]: 'badRequest_image_invalid',
    [ErrorType.inappropriateImage]: 'badRequest_image_inappropriateContent',
  } as Record<Partial<ErrorType>, string>,
};
